import axiosClient from "../../api/axiosClient";
import customNotification from "../../components/notification";
import moment from "moment";

const securityLogoutModel = {
    state: [],
    reducers: {
        setData(state, payload) {
            return { ...state, [payload.name]: payload.data,...payload };
        },
    },
    effects: (dispatch) => ({
        async addsecurityLogoutModelData(payload) {
            await axiosClient.post('/content/up_security_logout', payload).then(res => {
                if (res.data.status === 200) {
                    // getBalanceData(payload)
                    this.getsecurityLogoutModelShow(payload)
                    customNotification(res.data.message, "success")
                } else {
                    customNotification(res.data.message, "info")
                }
            }).catch(err => {
                customNotification(err.message, "error")
            })
        },
        async getsecurityLogoutModelShow(payload) {
            await axiosClient.post('/content/security_logout', payload).then(res => {
                if (res.data.status === 200) {
                   this.setData({ name: "security", data: res.data });
                } else {
                    customNotification(res.data.message, "info")
                }
            }).catch(err => {
                customNotification(err.message, "error")
            })
        }
    }),
};

export default securityLogoutModel;